import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative flex items-start" }
const _hoisted_2 = { class: "flex h-6 items-center" }
const _hoisted_3 = ["id", "aria-describedby", "name", "disabled"]
const _hoisted_4 = { class: "ml-3 text-sm leading-6" }
const _hoisted_5 = ["for"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]

import { ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { DynamicProperty } from "@/models/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputCheckbox3',
  props: {
  model: {
    type: DynamicProperty,
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    required: false,
    type: Boolean,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
let item = ref(props.model);

function customChange() {
  emit("change", item.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          id: __props.editMode ? _unref(item).key : _unref(item).key + '_view',
          "aria-describedby": `${_unref(item).label}-description`,
          name: _unref(item).key,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(item).data) = $event)),
          disabled: __props.disabled,
          onChange: customChange,
          type: "checkbox",
          class: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
        }, null, 40, _hoisted_3), [
          [_vModelCheckbox, _unref(item).data]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          for: _unref(item).key,
          class: "mt-1 text-sm text-gray-900"
        }, _toDisplayString(_unref(item).label.split(".", 1)[0]), 9, _hoisted_5)
      ])
    ]),
    (props.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "bg-white rounded-md my-2",
            id: 'outer-error_' + __props.model.key
          }, [
            _createElementVNode("p", {
              class: "font-medium text-sm text-red-2",
              id: 'error_' + __props.model.key
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})